import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      {/* Hero Section */}
      <section className="policy-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Privacy Policy</h1>
            <p className="hero-subtitle">How we protect your information</p>
            <p className="hero-description">
              Last updated: December 2024
            </p>
          </div>
        </div>
      </section>

      {/* Policy Content */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-text">
            <div className="policy-section">
              <h2>1. Information We Collect</h2>
              <p>
                We collect information you provide directly to us, such as when you:
              </p>
              <ul>
                <li>Fill out our contact form</li>
                <li>Subscribe to our newsletter</li>
                <li>Make a purchase</li>
                <li>Communicate with us</li>
              </ul>
              <p>
                The types of information we may collect include your name, email address, 
                phone number, and any other information you choose to provide.
              </p>
            </div>

            <div className="policy-section">
              <h2>2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide, maintain, and improve our services</li>
                <li>Process transactions and send related information</li>
                <li>Send technical notices, updates, and support messages</li>
                <li>Respond to your comments and questions</li>
                <li>Send you newsletters and promotional materials</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>3. Information Sharing</h2>
              <p>
                We do not sell, trade, or otherwise transfer your personal information to 
                third parties without your consent, except as described in this policy.
              </p>
              <p>We may share your information in the following circumstances:</p>
              <ul>
                <li>With your consent</li>
                <li>To comply with legal obligations</li>
                <li>To protect our rights and safety</li>
                <li>With service providers who assist us in operating our website</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>4. Data Security</h2>
              <p>
                We implement appropriate security measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction.
              </p>
              <p>
                However, no method of transmission over the internet or electronic storage 
                is 100% secure, so we cannot guarantee absolute security.
              </p>
            </div>

            <div className="policy-section">
              <h2>5. Cookies and Tracking</h2>
              <p>
                We use cookies and similar tracking technologies to enhance your experience 
                on our website. You can control cookie settings through your browser preferences.
              </p>
            </div>

            <div className="policy-section">
              <h2>6. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Delete your personal information</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>7. Changes to This Policy</h2>
              <p>
                We may update this privacy policy from time to time. We will notify you of 
                any changes by posting the new policy on this page and updating the "Last updated" date.
              </p>
            </div>

            <div className="policy-section">
              <h2>8. Contact Us</h2>
              <p>
                If you have any questions about this privacy policy, please contact us at:
              </p>
              <div className="contact-info">
                <p><strong>Email:</strong> DhrtiMaaOrganics@gmail.com</p>
                <p><strong>Phone:</strong> +91 8890060211</p>
                <p><strong>Address:</strong> Balaji Vihar-29, VKIA, Jaipur-302013</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
